import { v4 as uuidv4 } from 'uuid';
import Bg1 from '../../assets/img/home1/eng.jpg';
import Bg2 from '../../assets/img/home1/power.jpg';
import Bg3 from '../../assets/img/home1/eng2.jpg';
import Bg4 from '../../assets/img/home1/gas.jpg';
import Icon1 from '../../assets/img/icon/s1.png';
import Icon2 from '../../assets/img/icon/s2.png';
import Icon3 from '../../assets/img/icon/s3.png';
import Icon4 from '../../assets/img/icon/s4.png';

const servicesOneData = [
    {
        id: uuidv4(),
        bgImg: Bg1,
        icon: Icon1,
        heading: 'Izolații și Hidroizolații',
        btnText: 'Detalii',
        slug: 'izolatii-si-hidroizolatii',
    },
    {
        id: uuidv4(),
        bgImg: Bg2,
        icon: Icon2,
        heading: 'Instalații Electrice',
        btnText: 'Detalii',
        slug: 'instalatii-electrice',
    },
    {
        id: uuidv4(),
        bgImg: Bg3,
        icon: Icon3,
        heading: 'Vopsitorie și Tapet',
        btnText: 'Detalii',
        slug: 'vopsitorie-si-tapet',
    },
    {
        id: uuidv4(),
        bgImg: Bg4,
        icon: Icon4,
        heading: 'Gleturi și Finisaje',
        btnText: 'Detalii',
        slug: 'gleturi-si-finisaje',
    },
    {
        id: uuidv4(),
        bgImg: Bg1,
        icon: Icon1,
        heading: 'Gips-Carton',
        btnText: 'Detalii',
        slug: 'gips-carton',
    },
    {
        id: uuidv4(),
        bgImg: Bg2,
        icon: Icon2,
        heading: 'Tencuieli și Șape',
        btnText: 'Detalii',
        slug: 'tencuieli-si-sape',
    },
    {
        id: uuidv4(),
        bgImg: Bg3,
        icon: Icon3,
        heading: 'Montaj Pardoseli',
        btnText: 'Detalii',
        slug: 'montaj-pardoseli',
    },
    {
        id: uuidv4(),
        bgImg: Bg4,
        icon: Icon4,
        heading: 'Instalare AC',
        btnText: 'Detalii',
        slug: 'instalare-ac',
    },
    {
        id: uuidv4(),
        bgImg: Bg1,
        icon: Icon1,
        heading: 'HVAC',
        btnText: 'Detalii',
        slug: 'hvac',
    },
    {
        id: uuidv4(),
        bgImg: Bg2,
        icon: Icon2,
        heading: 'IBIX',
        btnText: 'Detalii',
        slug: 'ibix',
    },
];

export default servicesOneData;
